<template>
  <div class="page-content">
    <div class="card">
      <div class="card-header">
        <h1 class="card-header-title">{{ content.title }}</h1>
        <p class="card-header-description">{{ content.description }}</p>
      </div>
      <ItemList :items="localItems" :action="updateActiveItems" />
      <FieldInput
        name="other"
        type="text"
        :autoComplete="false"
        labelText=""
        placeholder="Other"
        :value="other"
        :touched="true"
        :onBlur="() => null"
        :onChange="(event) => updateOther(event.target.value)"
      />
      <CustomButton
        variation="primary"
        :onClick="() => action(formatListToSubmit)"
        :disabled="!multiSelectIsValid()"
        >Continue</CustomButton
      >
    </div>
  </div>
</template>
<script>
import ItemList from "@/components/ItemList.vue";
import CustomButton from "@/components/CustomButton.vue";
import FieldInput from "@/components/FieldInput.vue";

export default {
  data() {
    return {
      localItems: this.items,
      selectedEthnicities: [],
      other: "",
    };
  },
  props: {
    action: {
      type: Function,
      required: true,
    },
    content: {
      type: Object,
      required: true,
      default: () => ({
        title: String,
        description: String,
        image: String,
      }),
    },
    items: {
      type: Array,
      required: true,
      default: () => [
        {
          id: String,
          label: String,
          to: String,
          icon: String,
          text: String,
          description: String,
          isActive: Boolean,
          target_field: String,
          value: [String, Boolean, Array],
        },
      ],
    },
  },
  components: {
    ItemList,
    CustomButton,
    FieldInput,
  },
  computed: {
    formatListToSubmit() {
      this.addOtherToSelectedEthnicities();
      return this.selectedEthnicities;
    },
  },
  methods: {
    addOtherToSelectedEthnicities() {
      if (this.other !== "") {
        this.selectedEthnicities.push(this.other);
      }
    },
    multiSelectIsValid() {
      return this.localItems.find((item) => item.isActive) || this.other !== "";
    },
    updateActiveItems(selectedItem) {
      const result = this.localItems.map((el) =>
        el.id == selectedItem.id ? { ...el, isActive: !el.isActive } : el
      );

      this.localItems = result;

      if (this.selectedEthnicities.includes(selectedItem.value)) {
        this.selectedEthnicities = this.selectedEthnicities.filter(
          (value) => value !== selectedItem.value
        );
      } else {
        this.selectedEthnicities.push(selectedItem.value);
      }
    },
    updateOther(value) {
      this.other = value;
    },
  },
};
</script>
